import { render } from "./photodrop.vue?vue&type=template&id=6df88f92"
import script from "./photodrop.vue?vue&type=script&lang=js"
export * from "./photodrop.vue?vue&type=script&lang=js"

import "./photodrop.vue?vue&type=style&index=0&id=6df88f92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__